import { useParams } from "react-router-dom";

export function Review() {
  const { orderId } = useParams<{ orderId: string }>();

  return (
    <main style={{ padding: "2rem", fontFamily: "system-ui, sans-serif" }}>
      <h1>Order Review</h1>
      <p data-testid="order-id">Order: {orderId || "(none)"}</p>
      <p>
        This route is wired for direct loading at <code>/review/&lt;orderId&gt;</code>. The invoice
        review interface itself is implemented in Phase 6.
      </p>
    </main>
  );
}
